const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null && !Array.isArray(value);

export function getActionType(action: unknown): string | undefined {
    if (!isRecord(action)) {
        return undefined;
    }

    const maybeType = action.type;
    return typeof maybeType === 'string' ? maybeType : undefined;
}

export function getActionPayloadRecord(action: unknown): Record<string, unknown> {
    if (!isRecord(action)) {
        return {};
    }

    const maybePayload = action.payload;
    if (!isRecord(maybePayload)) {
        return {};
    }

    return maybePayload;
}
